import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterStudent, ToolbarComponent } from '../../../../../components'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
// import { useDispatch } from 'react-redux'
import classes from './Credit.module.css'
import { dashboardCredit, lowcredit } from '../../../../../assets/icons'
import { StaticAlt } from '../../../../../shared/utils/constants'
import { CreditHeadCells } from '../../../../../shared/data/headCells'
// import { setOpenImport } from '../../../../../redux/globalSlice'

const Credits = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type

  // const [openSchoolInfo, setSchoolInfo] = useState(false)
  const [search, setSearch] = useState('')

  // const dispatch = useDispatch()

  const [teachers, setTeachers] = useState(false)
  const [vanDriver, setVanDriver] = useState(false)
  // const { data: searchstudent } = useGlobal({
  //   userUrl: `${urls.STUDENT_SEARCH}${search}&grade_id=${'asdas'}&fee_status=${'asd'}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : ''}`,
  // })
  const { data: creditData, credit } = useGlobal({
    userUrl: `${urls.CREDIT_SECTION_LIST}?school_id=${customRole == 'Admin'  ? userSchoolId : ''}&filter=${teachers ? 'Teacher' : vanDriver ? 'Driver' : ''}`,
  })
  // const [update, setUpdate] = useState(false)
  // const [detail, setDetail] = useState(false)

  //   const rowData = search || gradeValue || feeStatus ? searchstudent : studentRow
  // console.log('------creditdata', creditData)

  const handleOpen = () => {
    // setSchoolInfo(true)
  }
  const [page, setPage] = useState(0)

  const credits = credit?.total_credit
  const lowcredits = credit?.remaining_credit
  const no_data_msg =
    customRole == 'Admin'
      ? 'Add Credits to start over'
      : userSchoolId
        ? 'Add Credits to start over'
        : 'Select Credits to see Credits'
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Credits'} subtitle={'Dashboard / Credits'} />
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <div className={classes.txtdiv}>
            <p className={classes.headtxt}>Total Credit</p>
            <p className={classes.txt}>{credits}</p>
          </div>
          <div className={classes.imgdiv}>
            <img src={dashboardCredit} alt={StaticAlt} />
          </div>
        </div>

        <div className={classes.container}>
          <div className={classes.txtdiv}>
            <p className={classes.headtxt}>Total Credit</p>
            <p className={lowcredits > 50 ? classes.txt : classes.lowcredit}>{lowcredits}</p>
          </div>
          {lowcredits < 50 && (
            <div className={classes.lowcreditsdiv}>
              <img src={lowcredit} alt={StaticAlt} />
              <p className={classes.lowcredtitxt}>You are low on Credits!</p>
            </div>
          )}
        </div>
      </div>
      <ToolbarComponent
        handleOpen={handleOpen}
        search={search}
        CreditText={'+ Add Credits'}
        setSearchItem={setSearch}
      >
        <FilterStudent
          teachers={teachers}
          setTeachers={setTeachers}
          vanDriver={vanDriver}
          setVanDriver={setVanDriver}
          teacherFilter={true}
        />
        {/* <ExportFile icon={FilterIcon} filename={'student'} jsonData={studentRow || []} /> */}
        {/* <FilterSection
          icon={ImportIcon}
          onClick={() => dispatch(setOpenImport(true))}
          title={'Import CSV'}
        /> */}
      </ToolbarComponent>
      {search ? (
        <p>No student Found!</p>
      ) : (
        <DataTable
          headCells={CreditHeadCells}
          rowData={creditData}
          credits
          page={page}
          setPage={setPage}
          school={false}
          search={search}
          noDataMsg={no_data_msg}
          // setUpdate={setUpdate}
          // handleDetailOpen={() => setDetail(true)}
        />
      )}
      {/* {openSchoolInfo && (
        <SchoolInfo
          customRole={customRole}
          userSchoolId={userSchoolId}
          open={openSchoolInfo}
          handleClose={() => setSchoolInfo(false)}
          title={'School Information'}
        />
      )}
      {update && <EditStudent open={update} handleClose={() => setUpdate(false)} />}
      {detail && <StudentDetail open={detail} handleClose={() => setDetail(false)} />} */}
    </div>
  )
}

export default Credits
